import type React from 'react';

import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import cn from 'classnames';

import st from './AttributeCard.module.sass';
import { ColorIcon } from '../color-icon/ColorIcon';

interface AttributeCardProps extends WithDataTestid, WithClassNameProp {
  icon: React.ReactNode;
  title: string;
  description?: string;
  size?: 'medium' | 'large';
  data: number | string | null;
  colorsConfig?: {
    color: string | null;
    tooltip?: string | null;
  }[];
  children?: React.ReactNode;
}

export function AttributeCard({
  icon,
  title,
  description = undefined,
  size = 'large',
  data,
  colorsConfig = undefined,
  children = undefined,
  className = undefined,
  'data-testid': dataTestId = 'AttributeCard',
}: AttributeCardProps): React.JSX.Element {
  return (
    <div
      className={cn(st.Card, st[`Card_${size}`], className)}
      data-testid={dataTestId}
    >
      <ColorIcon
        colorsConfig={colorsConfig}
        size={size}
      >
        {icon}
      </ColorIcon>

      <div className={st.Details}>
        <div className={st.Title}>{title}</div>
        <div
          className={cn(st.Description, {
            [st.Description_nullData as string]: data === null,
          })}
        >
          {description}
        </div>
        {!!children && <div className={st.Content}>{children}</div>}
      </div>
    </div>
  );
}
